// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__b43XZ","error":"Textarea_error__2ulWo","readonly":"Textarea_readonly__3rOnI","disabled":"Textarea_disabled__1pQIk"};